import { call, put } from 'redux-saga/effects';
import {
    requestApiKeyScopes,
    requestMyApiKeys,
    requestCreateApiKey,
    requestRevokeMyApiKey,
    requestAllApiKeys,
    requestUserApiKeys,
    requestRevokeUserApiKey,
    requestDeleteUserApiKey,
} from '../requests/apiKey';
import { showAlert } from '../../slices/alerts';

function* runRequest(requestFn, callback, args = []) {
    try {
        const response = yield call(requestFn, ...args);
        if (callback) callback(response.data);
    } catch (error) {
        const msg = error?.response?.data?.msg || error.message || 'Request failed';
        yield put(showAlert({ severity: 'error', message: msg }));
        if (callback) callback(null, msg);
    }
}

export function* handleGetApiKeyScopes(action) {
    yield call(runRequest, requestApiKeyScopes, action.payload.callback);
}

export function* handleGetMyApiKeys(action) {
    yield call(runRequest, requestMyApiKeys, action.payload.callback);
}

export function* handleCreateApiKey(action) {
    yield call(runRequest, requestCreateApiKey, action.payload.callback, [action.payload.data]);
}

export function* handleRevokeMyApiKey(action) {
    yield call(runRequest, requestRevokeMyApiKey, action.payload.callback, [action.payload.keyId]);
}

export function* handleGetAllApiKeys(action) {
    yield call(runRequest, requestAllApiKeys, action.payload.callback, [action.payload.params]);
}

export function* handleGetUserApiKeys(action) {
    yield call(runRequest, requestUserApiKeys, action.payload.callback, [action.payload.userId]);
}

export function* handleRevokeUserApiKey(action) {
    yield call(runRequest, requestRevokeUserApiKey, action.payload.callback, [action.payload.userId, action.payload.keyId]);
}

export function* handleDeleteUserApiKey(action) {
    yield call(runRequest, requestDeleteUserApiKey, action.payload.callback, [action.payload.userId, action.payload.keyId]);
}
